import { useState, useEffect } from 'react';
import { getFormByID, addFieldsToFormTable, removeFieldToFormTable } from '../../../../services/firebase/form/formTable';
import { capitalizeObjKeys } from '../../../../utils/utilities';
import { useLocation, useParams } from 'react-router-dom';
import { DB_fieldName, formFields, tbColumns } from './sectionConst';
import { ALERT_TYPE } from '../../../../constants/alert-type';
import { IconButton } from '@mui/material';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';

const useSectionCreatorPage = () => {
    const { formId } = useParams();
    const [formFieldState, setformFieldState] = useState({});
    const [formName, setFormName] = useState([]);
    const [formExists, setFormExists] = useState(false);
    const [tableColumns, setTableColumns] = useState([]);
    const [tableItems, setTableItems] = useState([]);
    const [showAlert, setShowAlert] = useState({ show: false, message: "", severity: "" });
    const [fields] = useState(formFields);
    const location = useLocation();

    let TABLE_NAME = "PDFTemplates"
    if (location.pathname.includes('/main/')) {
        TABLE_NAME = "MainFields"
    }

    useEffect(() => {
        setTableColumns(tbColumns);
        getForms();


    }, [])

    useEffect(() => {
        getForms();
    }, [formExists])

    //get All data from Forms Table
    const getForms = async () => {
        try {
            const data = await getFormByID(formId, TABLE_NAME);

            if (TABLE_NAME === "Forms" && data.FormName) 
                {setFormName(`${data.FormName} (${data.Form} - ${data.Type})`)} 
            else 
                { setFormName(`${data.Form} - ${data.Type}`) }

            setFormExists(true)

            //manipulate data to be displayed in Table
            const tbItems = createTableItemsData(data[DB_fieldName]);
            setTableItems(tbItems);
        } catch (error) {
            setFormExists(false)
            callAlertBar(true, `Form ID: ${formId} does not exist.`, ALERT_TYPE.ERROR)
        }
    }
    const handleFieldChange = (val, field) => {
        setformFieldState({ ...formFieldState, [field]: val })
    }

    const createTableItemsData = (sectionItems) => {
        let tbItems = []
        if (sectionItems) {
            sectionItems.forEach(item => {
                tbItems.push(createData(
                    item.SecName,
                    item.SecNumber,
                    item.SecOrder,
                    <IconButton
                        size="large"
                        aria-haspopup="true"
                        key={item.FieldName2}
                        onClick={() => buttonAction.handleDelete(item.FieldName2)}
                    >
                        <DeleteForeverOutlinedIcon sx={{ color: 'error.main' }} />
                    </IconButton>
                ))
            });
        }
        return tbItems;
    }

    const createData = (secName, secNumber, secOrder, action) => {
        return { secName, secNumber, secOrder, action };
    }

    const buttonAction = {
        handleSubmit: async () => {
            const newState = capitalizeObjKeys(formFieldState);
            try {
                await addFieldsToFormTable(newState, formId, DB_fieldName, TABLE_NAME);
                callAlertBar(true, "Your action was successful!", ALERT_TYPE.SUCCESS)
            } catch (error) {
                callAlertBar(true, error, ALERT_TYPE.ERROR)

            }
            setformFieldState({})
            setFormExists(false)
            setTimeout(() => {
                setFormExists(true)
            }, 500)
        },
        handleDelete: async (fieldName) => {
            await removeFieldToFormTable(fieldName, formId, DB_fieldName, TABLE_NAME);
            callAlertBar(true, "Field successfully deleted!", ALERT_TYPE.SUCCESS)
            setFormExists(false)
            setTimeout(() => {
                setFormExists(true)
            }, 100)
        }
    }

    const callAlertBar = (show, message, severity) => {
        setShowAlert({ show: show, message: message, severity: severity });
        setTimeout(() => {
            setShowAlert({ ...showAlert, show: false });
        }, 5000)
    }

    return {
        formFieldState,
        buttonAction,
        fields,
        handleFieldChange,
        formName,
        formExists,
        tableColumns,
        tableItems,
        showAlert
    }
}

export default useSectionCreatorPage;